/**
 *
 */
import { HEADER_HEIGHT } from './constants';

class Accordion {
  /**
   *
   */
  constructor() {
    this.config = {
      selectors: {
        title: '.Accordion__Title',
        frame: '.frame-type-template_accordion',
        content: '.ContentElement--Accordion',
        active: '.active',
      },
      activeClass: 'active',
      notLastClass: 'notLast',
      readyClass: 'ready',
      scrollSpeed: 500,
    };

    this.init();
  }

  /**
   *
   */
  init() {
    this.setEventListeners();
    this.setGroupedAccordionClass();

    $(this.config.selectors.frame).addClass(this.config.readyClass);
    $(this.config.selectors.content).slideUp(0);
    this.openAnchoredAccordion();
  }

  /**
   *
   */
  setEventListeners() {
    const { title } = this.config.selectors;

    $(title).on('click', this.onAccordionTitleClick.bind(this));
  }

  /**
   *
   */
  setGroupedAccordionClass() {
    const { frame } = this.config.selectors;
    const notLastClass = this.config.notLastClass;

    $(frame).each((i, e) => {
      if ($(e).next().is(frame)) {
        $(e).addClass(notLastClass);
      }
    });
  }

  /**
   *
   */
  openAnchoredAccordion() {
    //get the hash value
    var locationHash = window.location.hash;
    //split the value
    var hashSplit = locationHash.split('#');
    //get the tab number
    var contentID = hashSplit[1];

    if (!contentID || contentID.charAt(0) != 'c') {
      return;
    }

    const $contentElement = $(`#${contentID}`);
    const $contentBody = $contentElement.find(this.config.selectors.content);

    if ($contentBody) {
      $contentBody.slideDown(500, () =>
        $contentElement.addClass(this.config.activeClass)
      );
    }

    $('html, body')
      .stop()
      .animate({
        scrollTop: $contentElement.offset().top - HEADER_HEIGHT - 12,
      });
  }

  /**
   *
   * @param e
   */
  onAccordionTitleClick(e) {
    const { frame, active, content } = this.config.selectors;
    const activeClass = this.config.activeClass;

    const $title = $(e.currentTarget);
    const $listItem = $title.parents(frame);
    const $content = $listItem.find(content);

    if (!$listItem.is(active)) {
      $content.slideDown(500, () => {
        $listItem.addClass(activeClass);
        // scroll to the nearest end of the list item, in case not everything is in view.
        $listItem[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    } else {
      $content.slideUp(500, () => $listItem.removeClass(activeClass));
    }

    const $activeSibling = $listItem.siblings().filter(frame + active);
    const $activeSiblingContent = $activeSibling.find(content);

    $activeSiblingContent.slideUp(500, () =>
      $activeSibling.removeClass(activeClass)
    );
  }
}

export default Accordion;
